/**
 * mobileSidebar — 앱 셸(CRM · IT-CONSULTING · 설정) 좌사이드바의 "폰 모드" 공통 조각.
 * ----------------------------------------------------------------------------
 * 왜 있나
 *   폰(≤768px)에서 사이드바가 일반 흐름(flex item)으로 남아 있으면 240px 을 본문에서
 *   빼앗아, 390px 화면에 본문이 150px 밖에 안 남는다. CRM 은 이미 "오버레이 + 56px 슬롯"
 *   패턴으로 해결돼 있었는데 IT-CONSULTING(AutomationLayout)·설정(SettingsLayout)에는
 *   그 처리가 없어 폰에서 본문이 사실상 읽히지 않았다. 세 곳이 같은 동작을 하도록
 *   패턴을 여기 한 곳으로 모은다.
 *
 * 패턴
 *   1) `<SidebarSlot/>`     — 사이드바가 오버레이가 되면서 사라지는 자리를 56px 로 예약
 *                             (본문 리플로우 방지 + 접힘 상태 아이콘 레일이 그대로 보임).
 *   2) `<SidebarBackdrop/>` — 펼침 상태에서 본문 위를 덮는 어둡게 처리. 탭하면 닫힌다.
 *   3) `mobileAsideStyle()` — aside 를 absolute 오버레이로 띄우는 스타일 조각.
 *
 * 부모(레이아웃 루트)는 `position: relative` 여야 한다 — absolute 기준점.
 */
import React from "react";

/** 폰에서 사이드바가 오버레이로 뜰 때 본문 좌측에 남기는 아이콘 레일 폭(px). */
export const MOBILE_RAIL_WIDTH = 56;

/** 오버레이 사이드바가 비운 자리를 채우는 고정 슬롯 — 열고 닫아도 본문이 흔들리지 않는다. */
export function SidebarSlot({ width = MOBILE_RAIL_WIDTH }: { width?: number } = {}) {
  return <div style={{ width, minWidth: width, flexShrink: 0 }} aria-hidden />;
}

/** 펼친 사이드바 뒤의 본문을 덮는 배경 — 탭하면 닫는다. */
export function SidebarBackdrop({ onClose }: { onClose: () => void }) {
  return (
    <div
      onClick={onClose}
      aria-hidden
      style={{
        position: "absolute",
        inset: 0,
        zIndex: "var(--z-sticky)" as unknown as number,
        background: "rgba(15,23,42,0.35)",
      }}
    />
  );
}

/**
 * 폰에서 aside 에 덧씌우는 스타일. 데스크톱(isMobile=false)에서는 `null` 을 반환해
 * 기존 흐름 레이아웃을 그대로 둔다.
 */
export function mobileAsideStyle(isMobile: boolean, open: boolean): React.CSSProperties | null {
  if (!isMobile) return null;
  return {
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    zIndex: "var(--z-sticky)" as unknown as number,
    boxShadow: open ? "12px 0 32px rgba(15,23,42,0.18)" : "none",
  };
}
